import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class CRAService extends BaseService {

	constructor() {	
		super();
	}
	
	async getCRARates(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/cra-rates' + params);		
		return data;		
	}
	
	async getCRARate(id) {
		var data = await this.makeGETRequest('/api/resource/cra-rates/' + id);		
		return data;		
	}
	
	exportCRARates(paging) {	
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/cra-rates/export' + params);		
	};	
	
	async saveCRARate(rate, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/cra-rates/' + rate.taxRateId, rate);
		} else {
			saved = await this.makePOSTRequest('/api/resource/cra-rates', rate);
		}
		return saved;		
	}	
	
	async deleteCRARates(ids) {
		var data = await this.makeDELETERequest('/api/resource/cra-rates/multiple', ids);		
		return data;		
	}
	
}

